import React from "react";

/**
 * Asymmetric section masthead: kicker + serif headline on the left, supporting
 * paragraph set in a narrower column on the right, separated from the content
 * below by a single hairline. Replaces the centre-aligned
 * pill-badge / heading / grey-subtitle stack that ran on every section.
 */
export default function SectionHead({ kicker, title, children, light = false, className = "" }) {
  return (
    <div className={`pb-10 sm:pb-12 ${className}`}>
      <p className={light ? "kicker-light" : "kicker-rule"}>{kicker}</p>

      <div className="mt-6 grid grid-cols-1 gap-x-12 gap-y-5 lg:grid-cols-12 lg:items-end">
        <h2
          className={`text-balance font-display text-h2 font-semibold leading-[1.1] tracking-[-0.024em] sm:text-h2Lg lg:col-span-7 ${
            light ? "text-white" : "text-agri-ink"
          }`}
        >
          {title}
        </h2>
        {children && (
          <p
            className={`max-w-measure text-[1.0625rem] leading-[1.65] lg:col-span-5 ${
              light ? "text-white/65" : "text-agri-ink80"
            }`}
          >
            {children}
          </p>
        )}
      </div>

      <div
        className={`mt-10 h-px w-full ${light ? "bg-white/15" : "bg-agri-rule"}`}
      />
    </div>
  );
}
